// extracted by mini-css-extract-plugin
module.exports = {"inputCard":"InputCard_inputCard__LScry","button":"InputCard_button__HKbob"};